// removed by extract-text-webpack-plugin
module.exports = {"noButton":"_3FsUN0qVHG2SD6LC4BWKwt","havePopover":"eUuqnAdpMHW20WNJivpfM","popoverWrap":"_1gJOLxK8-U5tLEqviKWfTp","popover":"QbxC_ejn4KTGh2j6ihNAF"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/IconButton/IconButton.css
// module id = 1056
// module chunks = 58